// import { registerBlockType } from '@wordpress/blocks';

wp.blocks.registerBlockType("two-block/circle", {
	title: "Circle",
	icon: "smiley",
	category: "common",
	attributes: {
		circleColor: { type: 'string' },
		circleText: { type: 'string' },
	},
	edit: function (props) {
		function updateCircleColor(e) {
			props.setAttributes({ circleColor: e.target.value })
		}

		function updateCircleText(e) {
			props.setAttributes({ circleText: e.target.value })
		}

		return (
			<>
				<input placeholder='circle Color' value={props.attributes.circleColor} onChange={updateCircleColor} />
				<input placeholder='circle Text' value={props.attributes.circleText} onChange={updateCircleText} />
				<div class="circle_box">
					<div>
						<svg viewBox="0 0 200 200">
							<circle cx="100" cy="100" r="95" />
							<circle cx="100" cy="100" r="95" stroke={props.attributes.circleColor} />
						</svg>
						<span>{props.attributes.circleText}</span>
					</div>
				</div>
			</>
		)
	},
	save: function (props) {
		return (
			<div class="circle_box">
				<div>
					<svg viewBox="0 0 200 200">
						<circle cx="100" cy="100" r="95" />
						<circle cx="100" cy="100" r="95" stroke={props.attributes.circleColor} />
					</svg>
					<span>{props.attributes.circleText}</span>
				</div>
			</div>
		)
		return null

	}
})



wp.blocks.registerBlockStyle( 'core/button', {
    name: 'custom-button-style',
    label: 'My Button Style'
} );